var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isDesign
    ? _c("div", { staticClass: "ds_channel_list" }, [
        _c("div", { staticClass: "wrap" }, [
          _c(
            "div",
            { staticClass: "cover" },
            [
              _c("el-image", {
                attrs: {
                  src:
                    "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
                },
              }),
            ],
            1
          ),
          _vm._m(0),
        ]),
      ])
    : _c(
        "div",
        {
          staticClass: "ds-platform-card-item-by-train",
          on: { click: _vm.click },
        },
        [
          _c("div", { staticClass: "channel-card-wrap" }, [
            _c(
              "div",
              { staticClass: "cover" },
              [
                _c("el-image", {
                  attrs: {
                    src:
                      "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
                  },
                }),
              ],
              1
            ),
            _vm._m(1),
          ]),
        ]
      )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "desc" }, [
      _c("h3", { staticClass: "desc-title" }, [
        _c("span", { staticClass: "name" }, [_vm._v("1")]),
      ]),
      _c("div", { staticClass: "info" }, [
        _c("span", [_vm._v("15门课程")]),
        _c("span", [_vm._v("15个学时")]),
      ]),
      _c("div", { staticClass: "tags" }, [_c("span", [_vm._v("123人参加")])]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "desc" }, [
      _c("h3", { staticClass: "desc-title" }, [
        _c("span", { staticClass: "name" }, [_vm._v("1")]),
      ]),
      _c("div", { staticClass: "info" }, [
        _c("span", [_vm._v("15门课程")]),
        _c("span", [_vm._v("15个学时")]),
      ]),
      _c("div", { staticClass: "tags" }, [_c("span", [_vm._v("123人参加")])]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }